module.exports = __webpack_public_path__ + "static/exchange-rate-a6112870bd28e871497b82306dc8ef16.jpg";